"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformUserApi = exports.SdPlatformUserGetEmbeddableFields = exports.SdPlatformUserQueryEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformUserQueryEmbeddableFields;
(function (SdPlatformUserQueryEmbeddableFields) {
    SdPlatformUserQueryEmbeddableFields["BackendSystem"] = "backend_system";
    SdPlatformUserQueryEmbeddableFields["ChargebeeAddons"] = "chargebee_addons";
    SdPlatformUserQueryEmbeddableFields["ChargebeeCustomer"] = "chargebee_customer";
    SdPlatformUserQueryEmbeddableFields["ChargebeePlan"] = "chargebee_plan";
    SdPlatformUserQueryEmbeddableFields["ChargebeeSubscription"] = "chargebee_subscription";
    SdPlatformUserQueryEmbeddableFields["GlobalAccessDomains"] = "global_accessdomains";
    SdPlatformUserQueryEmbeddableFields["Organization"] = "organization";
})(SdPlatformUserQueryEmbeddableFields = exports.SdPlatformUserQueryEmbeddableFields || (exports.SdPlatformUserQueryEmbeddableFields = {}));
var SdPlatformUserGetEmbeddableFields;
(function (SdPlatformUserGetEmbeddableFields) {
    SdPlatformUserGetEmbeddableFields["BackendSystem"] = "backend_system";
    SdPlatformUserGetEmbeddableFields["ChargebeeAddons"] = "chargebee_addons";
    SdPlatformUserGetEmbeddableFields["ChargebeeCustomer"] = "chargebee_customer";
    SdPlatformUserGetEmbeddableFields["ChargebeePlan"] = "chargebee_plan";
    SdPlatformUserGetEmbeddableFields["ChargebeeSubscription"] = "chargebee_subscription";
    SdPlatformUserGetEmbeddableFields["GlobalAccessDomains"] = "global_accessdomains";
    SdPlatformUserGetEmbeddableFields["Organization"] = "organization";
    SdPlatformUserGetEmbeddableFields["UsedCredits"] = "used_credits";
})(SdPlatformUserGetEmbeddableFields = exports.SdPlatformUserGetEmbeddableFields || (exports.SdPlatformUserGetEmbeddableFields = {}));
/**
 * Operations for users.
 */
class SdPlatformUserApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "users";
    }
    /**
     * Gets the specific user by id
     * @param id - user id.
     * @param embed array of {@link SdPlatformUserGetEmbeddableFields} embeddable resources.
     */
    get(id, embed) {
        return super.__get(SdPlatformRequestId_1.RequestId.UserGet, id, embed);
    }
    /**
     * Register a new user. If successful a registration confirmation email will be sent.
     * @param body {@link SdPlatformRequestUserRegister}
     */
    register(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.UserRegister, ResourcesApi_1.Action.Post, "register", body);
    }
    /**
     * Query users.
     * @param body {@link SdPlatformUserQueryParameters}
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.UserQuery, body);
    }
    /**
     * Patch a user.
     * @param id - the id of a user
     * @param body {@link SdPlatformRequestUserPatch} properties to patch
     */
    // note - think about whether or not admin user resource should be default ?
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.UserPatch, id, body);
    }
    /**
     * Delete a user
     * @param id
     * @returns
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.UserDelete, id);
    }
    /**
     * Confirm a user registration.
     * @param token Token which was provided via registration confirmation email.
     * @returns
     */
    confirm(token) {
        return super.__action(SdPlatformRequestId_1.RequestId.UserConfirm, ResourcesApi_1.Action.Post, 'confirm', {
            token,
        });
    }
    /**
     * Request reset password token by email
     * @param body {@link SdPlatformRequestUserPasswordReset}
     */
    passwordReset(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.PasswordReset, ResourcesApi_1.Action.Post, 'password_reset', body);
    }
    /**
     * Change password using token
     * @param body {@see SdPlatformRequestUserPasswordResetConfirm}
     */
    passwordResetConfirm(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.PasswordResetConfirm, ResourcesApi_1.Action.Post, 'password_reset_confirm', body);
    }
    /**
     * Returns an array of data about authorized client applications and their refresh tokens.
     * @param  user_id
     * @returns the {@link SdPlatformGetResponse} with array of {@link SdPlatformResponseUserRefreshToken} as data
     */
    getUserRefreshTokens(user_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.UserRefreshToken, ResourcesApi_1.Action.Get, `users/${user_id}/apiclients`, {});
    }
    /**
     * Delete refresh token.
     * @param user_id
     * @param  refresh_token_id
     * @returns the {@link SdPlatformDeleteResponse} response.
     */
    deleteRefreshToken(user_id, refresh_token_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.UserDeleteRefreshToken, ResourcesApi_1.Action.Delete, `users/${user_id}/apiclients/${refresh_token_id}`, {});
    }
    /**
     * Disable mailing setting.
     * @param email
     * @param  property
     * @returns the {@link SdPlatformPatchResponse} response.
     */
    disableMailing(email, property) {
        return super.__action(SdPlatformRequestId_1.RequestId.UserDisableMailing, ResourcesApi_1.Action.Patch, `disable_mailing`, {
            email,
            property,
        });
    }
    /**
     * Get user tokens based backend system.
     * @param id - the id of a user
     * @param body {@link SdPlatformRequestUserToken}
     */
    token(id, body) {
        return super.__action(SdPlatformRequestId_1.RequestId.UserToken, ResourcesApi_1.Action.Post, `${id}/token`, body);
    }
}
exports.SdPlatformUserApi = SdPlatformUserApi;
//# sourceMappingURL=SdPlatformUserApi.js.map